import { Component } from '@angular/core';

@Component({
  selector: 'app-nosotrxs',
  imports: [],
  templateUrl: './nosotrxs.component.html',
  styleUrl: './nosotrxs.component.scss'
})
export class NosotrxsComponent {

}
